import * as React from "react";
import * as qs from "query-string";
import useReactRouter from "use-react-router";
import {
  getDiscoverFeed,
  getDiscoverFeedCategories,
  getDiscoverTrendingSections,
  ActionCreator,
} from "@vingle/wtf-sdk/actions/discover";
import {
  discoverCategoriesSelector,
  discoverPaginatedFeedSelector,
  discoverTrendingSectionsSelector,
} from "@vingle/wtf-sdk/selectors/discover";
// components
import { useCancelToken } from "@vingle/wtf-sdk/helpers/hook";
import { VISIBLE_AD_QS_KEY } from "../constants";
import { useStoreState, useActions } from "app/store";
export interface IHookProps extends ReturnType<typeof useProps> {}

export default function useProps() {
  const states = useStoreState(state => ({
    currentUser: state.app.currentUser,
    sections: discoverTrendingSectionsSelector(state),
    categories: discoverCategoriesSelector(state),
    feed: discoverPaginatedFeedSelector(state),
    pageState: state.discoverPage,
    selectedSection: state.discover.selectedSection,

    categoryErrorReason: state.discover.categoryErrorReason,
    realLocation: state.router.location,
  }));
  const actions = useActions({
    dispatchGetDiscoverFeed: getDiscoverFeed,
    dispatchGetDiscoverFeedCategories: getDiscoverFeedCategories,
    dispatchGetDiscoverTrendingSections: getDiscoverTrendingSections,
    dispatchSelectTrendingSection: ActionCreator.selectTrendingSection,
    dispatchClearDiscover: ActionCreator.clearDiscover,
  });
  const routers = useReactRouter();
  const showAd = React.useMemo(() => {
    const query = qs.parse(routers.location.search);
    return Boolean(query && VISIBLE_AD_QS_KEY in query);
  }, [routers.location.search]);
  const cancelToken = useCancelToken();
  return {
    ...states,
    ...actions,
    ...routers,
    showAd,
    cancelToken,
  };
}
